export enum TypeSignatureEnum {
  AtpvOwnHandwritingCurrencyPaper,
  AtpvQualifiedP7sCurrencyPaperPhoto,
  AtpveOwnHandwriting,
  AtpveAdvancedPdf,
  AtpveQualifiedP7sXml,
}
